import { Controller } from "@hotwired/stimulus"

// Toggles btn-primary on a region chip label as its underlying checkbox flips.
// Visual-only — submission goes through the normal form POST.
export default class extends Controller {
  toggle(event) {
    const checked = event.target.checked
    this.element.classList.toggle("btn-primary", checked)
    this.element.classList.toggle("btn-outline", !checked)
  }
}
